import React, { useState } from "react";

export const Gallery = (props) => {
  const [selectedImage, setSelectedImage] = useState(null); // État pour l'image sélectionnée

  const openImage = (image) => {
    setSelectedImage(image); // Définir l'image sélectionnée
  };

  const closeImage = () => {
    setSelectedImage(null); // Fermer la modale
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Galerie</h2>
          <p>
            Découvrez notre galerie, un espace où créativité et inspiration se rencontrent à travers une sélection de projets visuels réalisés avec soin et passion.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                    <img
                      src={d.largeImage}
                      alt=""
                      width="358"
                      height="300"
                      className="ImageGallery"
                      onClick={() => openImage(d.largeImage)} // Ouvrir l'image au clic
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>

      {/* Modale pour afficher l'image sélectionnée */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div className="modal-content">
            <img src={selectedImage} alt="Selected" className="large-image" />
          </div>
        </div>
      )}
    </div>
  );
};
